import { IFeed } from '@/models/feeds.model';
import { FeedsFormFieldsNames, TFeedFormValues } from './types';
import { SupportedLocales } from '@/models/localization.model';

export const normalizeFeedFormValues = (data?: IFeed | null): TFeedFormValues => {
  if (!data) {
    return {
      [FeedsFormFieldsNames.SLUG]: '',
      [FeedsFormFieldsNames.REGION_ID]: [],
      [FeedsFormFieldsNames.CATEGORIES]: [],
      [FeedsFormFieldsNames.ACTIVE]: true,
      [FeedsFormFieldsNames.TYPE]: 'google',
      [FeedsFormFieldsNames.STORE_IDS]: [],
      [FeedsFormFieldsNames.MIN_PRICE]: null,
      [FeedsFormFieldsNames.MAX_PRICE]: null,
      [FeedsFormFieldsNames.IN_STOCK_ONLY]: false,
      [FeedsFormFieldsNames.EXCLUDE_FROM_GENERAL]: true,
      [FeedsFormFieldsNames.ALL_CATEGORIES]: false,
      [FeedsFormFieldsNames.LOCALE]: {
        [SupportedLocales.RU]: {
          [FeedsFormFieldsNames.NAME]: '',
        },
        [SupportedLocales.UK]: {
          [FeedsFormFieldsNames.NAME]: '',
        },
      },
    };
  }
  const locales = data?.locale?.reduce(
    (acc, item) => {
      acc[item.locale] = {
        [FeedsFormFieldsNames.NAME]: item?.name ?? '',
      };
      return acc;
    },
    {} as Record<
      SupportedLocales,
      {
        [FeedsFormFieldsNames.NAME]: string;
      }
    >,
  );

  return {
    [FeedsFormFieldsNames.SLUG]: data.slug,
    [FeedsFormFieldsNames.REGION_ID]: data.regions.map((region) => ({ label: region.name ?? '', value: region.id })),
    [FeedsFormFieldsNames.CATEGORIES]: data.categories?.map((category) => ({
      label: category.name,
      value: category.id,
    })),
    [FeedsFormFieldsNames.ACTIVE]: data.active,
    [FeedsFormFieldsNames.TYPE]: data.type || 'google',
    [FeedsFormFieldsNames.STORE_IDS]: data.stores?.map((store) => ({ label: store.name, value: store.id })) ?? [],
    [FeedsFormFieldsNames.MIN_PRICE]: data.min_price ?? null,
    [FeedsFormFieldsNames.MAX_PRICE]: data.max_price ?? null,
    [FeedsFormFieldsNames.IN_STOCK_ONLY]: data.in_stock_only ?? false,
    [FeedsFormFieldsNames.EXCLUDE_FROM_GENERAL]: data.exclude_from_general ?? true,
    [FeedsFormFieldsNames.ALL_CATEGORIES]: data.all_categories ?? false,
    [FeedsFormFieldsNames.LOCALE]: locales,
  };
};
